import { Pipe, PipeTransform } from '@angular/core';
import { RecognitionObject } from './bbox-gallery-card.component';

@Pipe({ name: 'objectCountByTag', standalone: true })
export class ObjectCountByTagPipe implements PipeTransform {
  transform(objects: RecognitionObject[], tag: string): number {
    return objects.filter(o => o.tag === tag).length;
  }
}
